import { createLocation } from 'history'
import React from 'react'
import { history } from 'core/helpers/history'

const isModifiedEvent = event =>
    !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)

export const Link = ({ to, children, ...props }) => {
    const href = history.createHref(createLocation(to, null, undefined, history.location))

    return (
        <a
            {...props}
            href={href}
            onClick={event => {
                if (
                    !event.defaultPrevented && // onClick prevented default
                    event.button === 0 && // ignore everything but left clicks
                    !props.target && // let browser handle "target=_blank" etc.
                    !isModifiedEvent(event) // ignore clicks with modifier keys
                ) {
                    event.preventDefault()
                    history.push(to)
                }
            }}
        >
            {children}
        </a>
    )
}
